module.exports = __webpack_public_path__ + "static/media/logo-engager.985e8bab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-engager.svg
// module id = 483
// module chunks = 0